export * from './gestion-parametre.component';
